import React from 'react';
import { Button } from '../UI/Button';

type Props = {
  value: string;
  onChange?: (value: string) => void;
  rows?: number;
  label?: string;
  readOnly?: boolean;
  variant?: 'default' | 'composer';
};

export const JsonTextArea: React.FC<Props> = ({
  value,
  onChange,
  rows = 16,
  label,
  readOnly = false,
  variant = 'default',
}) => {
  const isComposer = variant === 'composer';

  const format = () => {
    if (!onChange) return;
    try {
      const parsed = JSON.parse(value);
      onChange(JSON.stringify(parsed, null, 2));
    } catch {
      /* mantém texto */
    }
  };

  return (
    <div>
      {label && (
        <label
          className={`block text-sm font-medium mb-1 ${
            isComposer ? 'text-slate-300' : 'text-gray-700'
          }`}
        >
          {label}
        </label>
      )}
      <div className="flex justify-end mb-1">
        {!readOnly && (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className={isComposer ? 'text-slate-300 hover:text-white hover:bg-white/10' : undefined}
            onClick={format}
          >
            Formatar JSON
          </Button>
        )}
      </div>
      <textarea
        className={`w-full font-mono text-sm rounded-md p-3 focus:outline-none focus:ring-2 ${
          isComposer
            ? 'border border-white/10 bg-[#363130] text-slate-100 placeholder:text-slate-500 focus:border-red-500/50 focus:ring-red-500/20'
            : 'border border-gray-300 bg-white text-gray-900 focus:ring-blue-500 focus:border-blue-500'
        }`}
        rows={rows}
        value={value}
        readOnly={readOnly}
        onChange={e => onChange?.(e.target.value)}
        spellCheck={false}
      />
    </div>
  );
};
